import type { Entry } from '../../../features/admin/modules/modules.model';

/** Reference to a signing entry, used as the form-field value. */
export interface SigningEntryRef {
  id: string;
  selectedInput?: string;
}

/** The single signer, as a reference to a users-module entry. */
export interface SigningSubmitter {
  id: string;
  selectedInput?: string;
}

/** Status slugs used by the signing module (backend webhook also writes 'Verlopen'). */
export const SigningStatusEnum = <const>{
  Nieuw: 'nieuw',
  AanvraagVerstuurd: 'aanvraag-verstuurd',
  Ondertekend: 'ondertekend',
  Verlopen: 'verlopen',
};
export type SigningStatus = (typeof SigningStatusEnum)[keyof typeof SigningStatusEnum];

export interface SigningTaxonomyValue {
  id?: string;
  name?: string;
  slug?: string;
  selectedInput?: string;
}

export interface SigningDocumentMetadata {
  documentName?: string;
  documentId?: string;
  blobUrl?: string;
  blobReference?: string;
  createdDateTime?: string | Date;
}

/** Documents-module entry as linked on the signing entry (`entry.document`). */
export interface SigningDocumentEntry extends Entry {
  entry: {
    archived: boolean;
    name: string;
    description?: string;
    share?: string;
    'document-type'?: unknown;
    file?: SigningDocumentMetadata;
  };
}

/** Signing-module entry (module code 'signing', backend PR 9092). */
export interface SigningEntry extends Entry {
  entry: {
    archived: boolean;
    name: string;
    document?: SigningDocumentEntry;
    submitter?: SigningSubmitter;
    status?: SigningTaxonomyValue;
    submissionId?: number;
    /** Sign-URL for the (single) submitter — pending backend support, may be missing. */
    submissionLink?: string;
  };
}

export interface SigningUploadState {
  isUploading: boolean;
  error: string | null;
}
